// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"_1uvzW9NVCs4PBA3je9dbo4"};